import { render, staticRenderFns } from "./BTableParticipants.vue?vue&type=template&id=0699e053&"
import script from "./BTableParticipants.vue?vue&type=script&lang=js&"
export * from "./BTableParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports